import { useNavigate } from "react-router-dom";
import { ROUTE, SHORTCUTS } from "../..//Constant";
import { useKeyboardShortcuts } from "../../Hook";
import { useRef } from "react";

export const KeyboardHandlerNavToPos = () => {
  const lastEnterTimeRefTab = useRef<number>(0);

  const navigate = useNavigate();

  useKeyboardShortcuts([
    {
      shortcut: SHORTCUTS.POS.NAVIGATE_TO_POS,
      options: {
        enabled: true,
        preventDefault: false,
        stopPropagation: true,
      },
      handler: (e) => {
        const activeEl = document.activeElement;
        if (activeEl && activeEl.getAttribute("aria-expanded") === "true") {
          return;
        }
        e.preventDefault();
        const now = Date.now();
        const delay = now - lastEnterTimeRefTab.current;
        if (delay < 500) {
          lastEnterTimeRefTab.current = 0;
          navigate(`/system/${ROUTE.sales_billing}`);
        } else {
          lastEnterTimeRefTab.current = now;
        }
      },
    },
  ]);

  return null;
};
